import {db} from '../firebase'

export function fetchTransactions(empresa, settings) {
    return dispatch => {
        dispatch({type: "FETCH_TRANSACTIONS"})
        db.collection(`empresa/${empresa}/registros`)
        .where('data', '>=', settings.inicio )
        .where('data', '<=', settings.fim)
        .get()
        .then( querySnapshot => {
            let dataArray = []
            querySnapshot.forEach( doc => {
                let allData = doc.data()
                dataArray.push({...allData, data: allData.data.toDate(), id:doc.id})
            })

            dispatch({type: "FETCH_TRANSACTIONS_FULFILLED", payload: dataArray})

        }).catch(error => {
            console.log(error)
            dispatch({type: "FETCH_TRANSACTIONS_REJECTED", payload: error})
        });
    }
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
    

export function getSaldoGeral(empresa) {
    return async dispatch => {
            await sleep(300)
            dispatch({type: "GET_SALDO_GERAL"})
            await sleep(1000)
            const getSaldo = await db.collection(`empresa`).doc(empresa).get()
            const saldo = getSaldo.data().saldo
            dispatch({type: "GET_SALDO_GERAL_FULFILLED", payload: saldo})
    }
}

export function fetchSaldoFromInicio(empresa, settings) {
    return dispatch => {
        dispatch({type: "FETCH_SALDO_INICIO"})
        db.collection(`empresa/${empresa}/registros`)
        .where('data', '>=', settings.inicio)
        .get()
        .then( querySnapshot => {
            let dataArray = []
            querySnapshot.forEach( doc => {
                let allData = doc.data()
                dataArray.push({...allData, id:doc.id})
            })

            const filterProcessado = dataArray.filter(x=> x.processado)

            const saldo = filterProcessado.reduce((init,x)=>{
                return  Number((x.debito? init - x.valor : init + x.valor).toFixed(2))
            },0)
        
            dispatch({type: "FETCH_SALDO_INICIO_FULFILLED", payload: saldo})

        }).catch(error => {
            console.log(error)
            dispatch({type: "FETCH_SALDO_INICIO_REJECTED", payload: error})
        });
    }
}


export function getItem(empresa, id) {
    return dispatch => {
        dispatch({type: "GET_ITEM"})
        db.collection(`empresa/${empresa}/registros`).doc(id)
        .get()
        .then( doc => {
            let itemObject = doc.data()
            itemObject = {...itemObject, id, data: itemObject.data.toDate()}
            dispatch({type: "GET_ITEM_FULFILLED", payload: itemObject})
        }).catch(error => {
            console.log(error)
            dispatch({type: "GET_ITEM_REJECTED", payload: error})
        });
    }
}

export function addItem(empresa, payload) {
    return dispatch => {
        dispatch({type: "ADD_ITEM"})
        db.collection(`empresa/${empresa}/registros`)
        .add(payload)
        .then( result => {
            dispatch({type: "ADD_ITEM_FULFILLED" })
        }).catch(error => {
            console.log(error)
            dispatch({type: "ADD_ITEM_REJECTED", payload: error})
        });
    }
}

export function editItem(empresa, id, payload) {
    return dispatch => {
        dispatch({type: "EDIT_ITEM"})
        db.collection(`empresa/${empresa}/registros`).doc(id)
        .set(payload)
        .then( result => {
            dispatch({type: "EDIT_ITEM_FULFILLED" })
        }).catch(error => {
            console.log(error)
            dispatch({type: "EDIT_ITEM_REJECTED", payload: error})
        });
    }
}

export function deleteItem(id, empresa) {
    return dispatch => {
        dispatch({type: "DELETE_ITEM"})
        db.collection(`empresa/${empresa}/registros`).doc(id)
        .delete()
        .then( result => {
            dispatch({type: "DELETE_ITEM_FULFILLED" })
        }).catch(error => {
            console.log(error)
            dispatch({type: "DELETE_ITEM_REJECTED", payload: error})
        });
    }
}

export function reset(){
    return dispatch =>{
        dispatch({type:"RESET"})
    }
}

export function resetErrors(){
    return dispatch =>{
        dispatch({type:"RESET_ERRORS"})
    }
}



// WEBPACK FOOTER //
// ./src/actions/transactionsActions.js